import React, { useState } from "react";
import { DsButton } from "../../ds";
import { Input } from "../ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";

export const ArchiveDialog = ({ open, onOpenChange, count, onConfirm, busy, testId = "archive-dialog" }) => {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testId}>
        <DialogHeader>
          <DialogTitle>Archive {count} item{count === 1 ? "" : "s"}?</DialogTitle>
          <DialogDescription>
            Archived items are hidden everywhere and never sent to n8n. Published items are never archived.
            You can restore them with the Archived status filter.
          </DialogDescription>
        </DialogHeader>
        <Input
          value={reason}
          maxLength={300}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason (optional), e.g. re-planning November"
          data-testid={`${testId}-reason`}
        />
        <DialogFooter>
          <DsButton onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Cancel</DsButton>
          <DsButton variant="no" disabled={busy || count === 0} onClick={() => onConfirm(reason.trim())} data-testid={`${testId}-confirm`}>Archive</DsButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
